import React from 'react'
import styled from 'styled-components'
import { ErrorBoundary } from 'react-error-boundary'

import { getTruckName, getTruckIcon } from 'utils/equipmentType'

const Container = styled.div`
  align-items: center;
  display: inline-flex;
  text-transform: uppercase;

  > svg:first-child {
    margin-right: 10px;
  }
`

export default function Equipment({
  equipmentType,
  iconSize = 24,
}: {
  equipmentType: string
  iconSize?: number
}) {
  if (!equipmentType) {
    return null
  }

  return (
    <Container>
      <ErrorBoundary fallback={<span>{equipmentType}</span>}>
        {React.createElement(getTruckIcon(equipmentType), {
          height: iconSize,
          width: iconSize,
        })}
        {getTruckName(equipmentType)}
      </ErrorBoundary>
    </Container>
  )
}
